var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{attrs:{"api-key":_vm.apiKey,"cloud-channel":"8","disabled":_vm.readOnly,"init":{
      height: _vm.boxHeight,

      plugins: [
        'accordion', 'anchor', 'autolink', 'autoresize', 'autosave', 'charmap', 'code', 'codesample', 'directionality', 'emoticons', 
        'fullscreen', 'help', 'image', 'importcss', 'insertdatetime', 'link', 'lists', 'lists advlist', 'media', 'nonbreaking', 
        'pagebreak', 'preview', 'quickbars', 'save', 'searchreplace', 'table', 'visualblocks', 'visualchars', 'wordcount'
      ],

      menubar: 'file edit insert view format table tools help',
      menu: {
        file: { title: 'File', items: 'newdocument restoredraft | preview | print' },
        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
        insert: { title: 'Insert', items: 'image link media codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor | insertdatetime' },
        view: { title: 'View', items: 'code | visualaid visualchars visualblocks | preview fullscreen ' },
        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | removeformat' },
        table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
        tools: { title: 'Tools', items: 'code wordcount' },
        help: { title: 'Help', items: 'help' }
      },

      toolbar_mode: 'sliding',
      font_size_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
      toolbar1: 'fontsize | fontfamily | blocks',
      toolbar2:
        'undo redo | forecolor backcolor bold italic underline subscript superscript | ' +
        'alignleft aligncenter alignright alignjustify | ' +
        'bullist numlist outdent indent | link unlink | table image | removeformat code | fullscreen' 
        + ' | formathtml'
        ,

      images_reuse_filename: true,
      images_upload_handler: _vm.sendFile,
      relative_urls: false,
      remove_script_host: true,
      extended_valid_elements: '*[*]',
      valid_elements: '*[*]',

      font_family_formats: 
        '굴림=굴림;굴림체=굴림체;궁서=궁서;궁서체=궁서체;돋움=돋움;돋움체=돋움체;바탕=바탕;바탕체=바탕체;나눔고딕=NanumGothic,serif;' +
        'Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;' +
        'Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;' +
        'Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;' +
        'Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;' +
        'Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats;',

      setup: (editor) => {
        editor.ui.registry.addButton('formathtml', {
          text: 'Format HTML',
          tooltip: 'Prettier 정렬 HTML 보기/수정',
          onAction: () => {
            this.openFormattedHtml(editor)
          }
        })

        editor.ui.registry.addMenuItem('formathtml', {
          text: 'Format HTML',
          onAction: () => {
            this.openFormattedHtml(editor)
          }
        })
      }

    }},on:{"onChange":_vm.contentChanged},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('v-dialog',{attrs:{"max-width":"1200","scrollable":""},model:{value:(_vm.htmlDialog),callback:function ($$v) {_vm.htmlDialog=$$v},expression:"htmlDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"d-flex justify-space-between align-center"},[_c('span',[_vm._v("Formatted HTML")]),_c('div',{staticClass:"html-btn-group"},[_c('v-btn',{attrs:{"small":""},on:{"click":_vm.formatDialogHtml}},[_vm._v("정렬")]),_c('v-btn',{attrs:{"small":""},on:{"click":_vm.copyFormattedHtml}},[_vm._v("복사")]),_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.applyFormattedHtml}},[_vm._v("적용")]),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.htmlDialog = false}}},[_vm._v("닫기")])],1)]),_c('v-card-text',{staticClass:"html-dialog-body"},[_c('v-textarea',{staticStyle:{"font-family":"Consolas, Monaco, monospace","font-size":"14px"},attrs:{"outlined":"","auto-grow":"","rows":"20"},model:{value:(_vm.formattedHtml),callback:function ($$v) {_vm.formattedHtml=$$v},expression:"formattedHtml"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }